/**
 * Map URL search params from zoning-check / deep links into advisor form defaults.
 * Supports: address, description, proposedUse, propertyType, projectType
 * City switch (same App template): city | jurisdiction | packageId
 */
export function defaultsFromSearchParams(searchParams) {
  if (!searchParams) return {};
  const get = (key) => {
    const v = searchParams.get?.(key);
    return v != null && String(v).trim() ? String(v).trim() : null;
  };
  const out = {};
  const address = get('address') || get('location');
  const description = get('description') || get('use') || get('proposedUse');
  const proposedUse = get('proposedUse') || get('use');
  const propertyType = get('propertyType') || get('projectType');
  if (address) {
    out.address = address;
    out.location = address;
  }
  if (description) out.description = description;
  if (proposedUse) out.proposedUse = proposedUse;
  if (propertyType) {
    out.propertyType = propertyType;
    out.projectType = propertyType;
  }
  const truthy = (v) => /^(1|true|yes|y)$/i.test(String(v || '').trim());
  if (truthy(get('foodHandling') || get('food'))) out.foodHandling = true;
  if (truthy(get('servesAlcohol') || get('alcohol'))) out.servesAlcohol = true;
  if (truthy(get('outdoorSeating') || get('outdoor'))) out.outdoorSeating = true;
  // Pitch-deck / runbook deep links: run advise once after prefill.
  if (truthy(get('autoAdvise') || get('advise'))) out.autoAdvise = true;
  const typeId = get('type') || get('applicationTypeId') || get('applicationType');
  if (typeId) out.preferredApplicationTypeId = typeId;
  return out;
}

/** Package id from ?city= / ?jurisdiction= / ?packageId= (multi-city demo without separate apps). */
export function packageIdFromSearchParams(searchParams, fallback = null) {
  if (!searchParams) return fallback;
  const raw = searchParams.get?.('city')
    || searchParams.get?.('jurisdiction')
    || searchParams.get?.('packageId');
  const id = raw != null ? String(raw).trim().toLowerCase() : '';
  return id || fallback;
}
